import { ReactElement } from 'react';
import classNames from 'classnames';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import styles from './Button.module.scss';

interface IProps extends IconButtonProps {
  className?: string;
  disabled?: boolean;
  size?: IconButtonProps['size'];
}

const ButtonIcon = ({
  className,
  disabled,
  size = 'large',
  children,
  ...props
}: IProps): ReactElement => (
  <IconButton
    {...props}
    disabled={disabled}
    className={classNames({ [styles.disabled]: disabled }, className)}
    size={size}
  >
    {children}
  </IconButton>
);

export default ButtonIcon;
